var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "black",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16224_87883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7969,
    y: 12.8,
    width: 38.4,
    height: 38.4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16224_87883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9966 34.24L24.1566 42.08C23.8632 42.3733 23.4899 42.52 23.0366 42.52C22.5832 42.52 22.2099 42.3733 21.9166 42.08C21.6232 41.7866 21.4766 41.4133 21.4766 40.96C21.4766 40.5066 21.6232 40.1333 21.9166 39.84L29.7566 32L21.9166 24.16C21.6232 23.8666 21.4766 23.4933 21.4766 23.04C21.4766 22.5866 21.6232 22.2133 21.9166 21.92C22.2099 21.6266 22.5832 21.48 23.0366 21.48C23.4899 21.48 23.8632 21.6266 24.1566 21.92L31.9966 29.76L39.8366 21.92C40.1299 21.6266 40.5032 21.48 40.9566 21.48C41.4099 21.48 41.7832 21.6266 42.0766 21.92C42.3699 22.2133 42.5166 22.5866 42.5166 23.04C42.5166 23.4933 42.3699 23.8666 42.0766 24.16L34.2366 32L42.0766 39.84C42.3699 40.1333 42.5166 40.5066 42.5166 40.96C42.5166 41.4133 42.3699 41.7866 42.0766 42.08C41.7832 42.3733 41.4099 42.52 40.9566 42.52C40.5032 42.52 40.1299 42.3733 39.8366 42.08L31.9966 34.24Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleDark);
export default __webpack_public_path__ + "static/media/CloseCircleDark.d211c0119b57de1acc123f9af8e28b90.svg";
export { ForwardRef as ReactComponent };